function countdownOrders() {

  function countdownStart() {

    var domTarget = document.getElementById('prd-time');

    if (domTarget) {

      var obj = {
        data: 'ZW1tZW1lZGlh',
        dayToShip: 0,
        hourLimit: 16,
        lastDay: 5,
        daysToDelivery: 1,
        deliveryRange: 0
      };

      var formData = new URLSearchParams();
      for (var key in obj) {
        formData.append(key, obj[key]);
      }

      fetch('https://syncfiles.emmemedia.net/instant-time-delivery.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData.toString()
      })
        .then(response => response.json())
        .then(data => {
          if (data) {
            domTarget.innerHTML = 'Ordina <strong>' + data.order_by + '</strong> per riceverlo <strong>' + data.end_delivery + '</strong>';
          }
        });

    }

  }

  countdownStart();
  setInterval(function () {
    /* Ripeti ogni minuto */
    countdownStart();
  }, 60000);

}

document.addEventListener('DOMContentLoaded', function () {
  countdownOrders();
});
